/**
 * Keyboard shortcuts help modal — shown when user presses "?"
 */
import React from "react";
import { t, Trans } from "@lingui/macro";

import Modal from "components/Modal/Modal";
import "./KeyboardShortcutsModal.css";

type ShortcutRow = {
  keys: string[];
  description: string;
  scope?: string;
};

const SHORTCUTS: ShortcutRow[] = [
  { keys: ["?"], description: "Show keyboard shortcuts", scope: "Global" },
  { keys: ["Esc"], description: "Close modal / cancel", scope: "Global" },
  { keys: ["L"], description: "Switch to Long", scope: "Exchange" },
  { keys: ["S"], description: "Switch to Short", scope: "Exchange" },
  { keys: ["M"], description: "Market order", scope: "Exchange" },
  { keys: ["K"], description: "Limit order", scope: "Exchange" },
  { keys: ["T"], description: "Trigger order", scope: "Exchange" },
  { keys: ["C"], description: "Focus collateral input", scope: "Exchange" },
  { keys: ["+", "-"], description: "Increase / decrease leverage by 1×", scope: "Exchange" },
  { keys: ["Ctrl", "Enter"], description: "Confirm trade (when form is filled)", scope: "Exchange" },
];

type Props = {
  isVisible: boolean;
  setIsVisible: (v: boolean) => void;
};

export function KeyboardShortcutsModal({ isVisible, setIsVisible }: Props) {
  const scopes = [...new Set(SHORTCUTS.map((s) => s.scope || "Global"))];

  return (
    <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={t`Keyboard Shortcuts`}>
      <div className="KSM-root">
        {scopes.map((scope) => (
          <div key={scope} className="KSM-group">
            <div className="KSM-scope-label">{scope}</div>
            {SHORTCUTS.filter((s) => (s.scope || "Global") === scope).map((row, i) => (
              <div key={i} className="KSM-row">
                <div className="KSM-keys">
                  {row.keys.map((k, ki) => (
                    <React.Fragment key={ki}>
                      {ki > 0 && <span className="KSM-sep">/</span>}
                      <kbd className="KSM-key">{k}</kbd>
                    </React.Fragment>
                  ))}
                </div>
                <div className="KSM-desc">{row.description}</div>
              </div>
            ))}
          </div>
        ))}
        <p className="KSM-note">
          <Trans>Shortcuts are disabled while typing in an input field.</Trans>
        </p>
      </div>
    </Modal>
  );
}
